import { Module } from "vuex";
import { IRootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IContentProvider } from "@/models/contentprovider";

export interface IContentProviderState {
    contentProvidersList: IContentProvider[] | null;
    selectedContentProvider: IContentProvider | null;
    isSelectedContentProvider: boolean;
    error: any;
}

export const getDefaultCPState = (): IContentProviderState => {
    return {
        contentProvidersList: [],
        selectedContentProvider: null,
        isSelectedContentProvider: false,
        error: null,
    };
};

const state = getDefaultCPState();

const namespaced: boolean = true;

export const contentProviders: Module<IContentProviderState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
